import type { ApiEnvelope } from '../types';

async function call<T>(path: string, method: string, body?: unknown): Promise<T> {
  const res = await fetch(`/api/${path}`, {
    method,
    credentials: 'include',
    headers: body ? { 'Content-Type': 'application/json' } : undefined,
    body: body ? JSON.stringify(body) : undefined,
  });
  const envelope: ApiEnvelope<T> = await res.json();
  if (!envelope.ok) {
    throw new Error(envelope.error ?? 'Request failed');
  }
  return envelope.data as T;
}

export const sessionClient = {
  login(email: string, password: string): Promise<{ email: string }> {
    return call('login', 'POST', { email, password });
  },

  me(): Promise<{ email: string; secret: string }> {
    return call('me', 'GET');
  },

  logout(): Promise<void> {
    return call('logout', 'POST');
  },

  publicKey(): Promise<{ publicKey: string }> {
    return call('public-key', 'GET');
  },
};
